import styled from 'styled-components';
import { black, lightGray, middleGray } from 'styles/colorProvider';

export const Container = styled.div`
  width: 100%;
  height: 85px;
  min-height: 70px;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${lightGray};
  border-radius: 20px;
  cursor: pointer;
  margin-top: 15px;
  font-size: 13px;
  position: relative;

  .description {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;

    @media (max-width: 1000px) {
      justify-content: center;
      flex-direction: column;
      align-items: flex-start;
      }

    .iconCar {
      width: 5%;
      margin-left: 2%;

      @media (max-width: 1000px) {
      display: none;
      }
    }

    @media (max-width: 1000px) {
      flex-wrap: wrap;
      width: 100%;
      padding: 10px;
    }
  }

  @media (max-width: 1000px) {
    margin-bottom: 10%;
    height: auto;
  }
`;

export const Div = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  margin-left: 4%;
  width: 80%;

  @media (max-width: 1000px) {
    margin-bottom: 10px;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  width: 25%;

  @media (max-width: 1000px) {
    display: none;
  }
`;

export const Title = styled.h3`
  font-size: 14px;
  color: ${black};
  font-weight: 500;
  margin: 0;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${middleGray};
  margin: 0;
`;

export const IconMobile = styled.div`
  display: none;
  
  @media (max-width: 1000px) {
    display: flex;
    flex-direction: row;
    width: 10%;
    position: absolute;
    margin-left: 80%;
    justify-content: center;
    align-items: center;
    }
`